import { RootDispatch } from '../store';

export const Statuses = ['OFFLINE', 'UNREACHABLE', 'ONLINE', 'CONNECTING'] as const;

export type Status = (typeof Statuses)[number];

export type NetworkStatusState = {
  status: Status;
};

const initialState: NetworkStatusState = {
  status: 'OFFLINE',
};

export const networkStatus = {
  effects: (dispatch: RootDispatch) => ({
    handleNetworkStatusChange(status: string) {
      const isValidStatus = (status: string): status is Status =>
        Statuses.includes(status as Status);
      if (isValidStatus(status)) {
        dispatch.networkStatus.updateNetworkStatus(status);
      }
    },
  }),
  reducers: {
    updateNetworkStatus(_: NetworkStatusState, payload: Status): NetworkStatusState {
      return { status: payload };
    },
  },
  state: initialState,
};
